export const MAX_CARD_INSTALLMENTS = 12;
